/**
 * Where a pointer is, as a Rive "look" value: artboard px measured from the
 * point a character's gaze starts at (0, 0 = straight ahead; x grows right,
 * y grows down). For a canvas drawn with `Fit.Contain` + `Alignment.Center`,
 * so the letterbox bands are accounted for. The pointer may be anywhere on
 * the page: values past the artboard are expected, and each file's own
 * converters saturate them softly.
 *
 * Shared by every Ka Rive file (the oral exam's `KaLanding`, the floating
 * icon): only the artboard size and the eye point differ.
 */

export type RiveLookArt = {
  /** Intrinsic artboard size. */
  width: number;
  height: number;
  /** The origin of lookX / lookY, in artboard px. */
  eyes: { x: number; y: number };
};

type Rect = { left: number; top: number; width: number; height: number };

export function riveLook(
  clientX: number,
  clientY: number,
  canvas: Rect,
  art: RiveLookArt,
): { lookX: number; lookY: number } {
  const scale = Math.min(canvas.width / art.width, canvas.height / art.height);
  if (!(scale > 0)) return { lookX: 0, lookY: 0 };
  const left = canvas.left + (canvas.width - art.width * scale) / 2;
  const top = canvas.top + (canvas.height - art.height * scale) / 2;
  return {
    lookX: (clientX - left) / scale - art.eyes.x,
    lookY: (clientY - top) / scale - art.eyes.y,
  };
}
